import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';

import modaalCss from '../../../node_modules/modaal/dist/css/modaal.css';
import modaal from 'modaal';

import ScrollReveal from "scrollreveal";


import SlickCarousel from 'slick-carousel';
import SlickCarouselCss from "slick-carousel/slick/slick-theme.scss";
import SlickCarouselCsss from "slick-carousel/slick/slick.scss";

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

      //SPメニューの高さ取得
    function menuHight() {
        var win = $(window).innerWidth();
        if (win > 750) {
            return false;
        }

        var $smpHeaderHeight = $('.l-header').height();
        var windowHeight = window.innerHeight;
        var winH = windowHeight - $smpHeaderHeight;

        console.log($smpHeaderHeight);

        //動かすターゲットを取得
        var targetSlidebarWrap = $('.c-slidebar-menu'),
            targetSlidebarMenu = $('.c-slidebar__parent'),
            targetSlidebarBtn = $('.c-slidebar-menu__parent');


        //いざ実行(クリックしたら処理を実行する)
        targetSlidebarBtn.on('click', function () {
            $('.c-slidebar-menu').toggleClass('is-active');

        });
    }

      //フッターメニューSPスライド
      function menuSlide() {
          var win = $(window).innerWidth();
          if (win > 750) {
              return false;
          }
          $('.l-footer__block').on('click',function() {
              $(this).children(".l-footer__menutitle").toggleClass('is-open');
              $(this).children(".l-footer__menulist.is-sub").slideToggle();
          })
      }
      //owlcarousel
      function owlCarousel() {
          var owls = $('.owl-carousel');
          if (owls.length === 0) {
              return false
          }
          //->スライダー
          owls.imagesLoaded(function () {
              $('.c-main-visual__slider').owlCarousel({
                  items: 1,
                  margin: 0,
                  dots: true,
                  loop: true,
                  nav: false,
                  autoplayHoverPause: true,
                  autoplay: true,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<img src="../assets/images/icon-slider-prev.svg" />','<img src="../assets/images/icon-slider-next.svg" />'],
              });
          });
          //->カルーセル
          owls.imagesLoaded(function () {
              $('.c-main-visual__carousel').owlCarousel({
                  items: 1,
                  margin: 16,
                  dots: true,
                  loop: true,
                  nav: true,
                  autoplayHoverPause: true,
                  autoplay: false,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  center: true,
                  navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>','<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
                  responsive : {
                    // breakpoint from 0 up
                    0 : {
                      stagePadding: 32,
                    },
                    // breakpoint from 750  up
                    750 : {
                      stagePadding: 64,
                    },
                    // breakpoint from 950 up
                    950 : {
                      stagePadding: 156,
                    },
                    1400 : {
                      stagePadding: 312,
                    }
                  }
              });
          });
          //->カルーセル_ノーマル
          owls.imagesLoaded(function () {
          $('.c-main-visual__carousel.is-normal').owlCarousel({
            items: 1,
            margin: 8,
            dots: true,
            loop: true,
            nav: true,
            autoplayHoverPause: true,
            autoplay: false,
            autoplaySpeed: 500,
            autoWidth: false,
            autoHeight: false,
            center: true,
            navText: ['<div class="c-main-visual__nav is-left"><i class="fa fa-angle-left" aria-hidden="true"></i></div>','<div class="c-main-visual__nav is-right"><i class="fa fa-angle-right" aria-hidden="true"></i></div>'],
            responsive : {
              // breakpoint from 0 up
              0 : {
                stagePadding: 32,
              },
              // breakpoint from 750  up
              750 : {
                stagePadding: 64,
              },
              // breakpoint from 950 up
              950 : {
                stagePadding: 156,
              },
              1400 : {
                stagePadding: 312,
              }
            }
          });
        });
          //->カルーセル_レイヤー
          owls.imagesLoaded(function () {
            $('.c-main-visual-layer__carousel').owlCarousel({
              items: 1,
              margin: 0,
              dots: true,
              loop: true,
              nav: false,
              autoplayHoverPause: true,
              autoplay: true,
              autoplaySpeed: 500,
              autoWidth: false,
              autoHeight: false,
              center: true,
              navText: ['<img src="..//assets/images/icon-slider-prev.svg" />','<img src="../assets/images/icon-slider-next.svg" />'],
            });
          });
          //->カード_カルーセル
          owls.imagesLoaded(function () {
              $('.js-card-slider').owlCarousel({
                  dots: true,
                  loop: true,
                  nav: true,
                  autoplayHoverPause: true,
                  autoplay: true,
                  autoplaySpeed: 500,
                  autoWidth: false,
                  autoHeight: false,
                  navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>','<i class="fa fa-angle-right" aria-hidden="true"></i>'],
                  responsive : {
                    // breakpoint from 0 up
                    0 : {
                      margin: 25,
                      stagePadding: 80,
                      items: 1,
                      center: true,
                    },
                    // breakpoint from 750 up
                    750 : {
                      margin: 24,
                      stagePadding: 0,
                      items: 4,
                      center: false,
                    }
                  }
              });
          });
      }

    // Modaal設置
    function modaal() {
      $(".c-search-composite__block").modaal({
        content_source: '#inline'
      });
    }

    // modal開いたときに押したボタンと一致するタブを開く
    function searchModal() {
      $('.c-search-composite__block').on('click', function() {
        var target = $(this).data().searchTarget;
        tabOpen(target);
      });

      $('.c-search-modal__title').on('click', function () {
        $(this).toggleClass('is-open');
        $(this).next(".c-search-modal__content").slideToggle(200);
      });

      // 最初アコーディオンを開く処理
      function tabOpen(data) {
        $('.c-search-modal__content').hide();
        $('.c-search-modal__title').removeClass('is-open');
        $('.c-search-modal__block[data-search-name="' + data + '"] .c-search-modal__title').addClass('is-open');
        $('.c-search-modal__block[data-search-name="' + data + '"] .c-search-modal__title').next('.c-search-modal__content').slideDown(200);
      }
    }

    // slick
    function slick_slider() {
      $('.js-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.js-slider-nav'
      });
      $('.js-slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.js-slider-for',
        dots: true,
        centerMode: false,
        focusOnSelect: true
      });
    }


    /**
     * ループスライダー
     */
    function loopSlider() {
      var targetInner = $('.c-loop-slider__inner'),
        targetInnerUl = $('.c-loop-slider__inner > ul'),
        targetInnerItems = targetInnerUl.children(),
        slideEasing = 'linear',
        slideSpeed = 4000;
      for (var i = 0; i < 2; i++) {
        targetInnerItems.clone().prependTo(targetInnerUl);
        targetInnerItems.clone().appendTo(targetInnerUl);
      }
      targetInnerUl.each(function () {
        var self = $(this);
        //liの個数を取得
        var selfChildItemLength = self.find('li').length;
        //liの幅を取得
        var selfChildList = self.find('li').innerWidth();
        //ulを複製する
        // self.clone().appendTo( targetInner );
        //ulの親divに幅を付与する
        // targetInner.width( ( selfChildList * selfChildItemLength ) * 2 )
        targetInner.width(selfChildList * selfChildItemLength);

        // 親divをアニメーションさせる
        function galleryAnimate() {
          targetInner.animate(
            {
              left: '-' + ((selfChildList * selfChildItemLength) / 3 * 2) + 'px'
            }, {
              duration: slideSpeed * selfChildItemLength,
              easing: slideEasing,
              complete: function () {
                targetInner.css({
                  left: 0
                });
                galleryAnimate()
              }
            }
          );
        }

        galleryAnimate()
      });
    }

    function reveal() {
      //- スクロールリーバル
      window.sr = ScrollReveal({duration: 600,mobile:false});
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }


      sr.reveal(".c-main-visual__image", {scale: 1, duration: 1600,origin:'left',distance: '50px',}, 100);
      sr.reveal(".l-page-header__image", {scale: 1, duration: 1000,origin:'left',distance: '25px',}, 100);
      sr.reveal(".c-bg-parallax", {scale: 1, duration: 500,delay: 500,origin:'left',distance: '0',}, 100);


      function myCallback (el) {
        el.classList.add('is-animating');
      }

      ScrollReveal().reveal('.c-main-visual', { beforeReveal: myCallback });
      ScrollReveal().reveal('.l-page-header', { beforeReveal: myCallback });
    }

    $(function() {
        menuSlide();
        owlCarousel();
        modaal();
        searchModal();
        loopSlider();
        slick_slider();
        reveal();
    });
  }
}

window.GApp = new App();
